import { c as V } from "./carousel.messages-243a8ce8.js";
const r = {
  closeAlert: "Zatvoriť oznam"
}, n = {
  month: {
    1: "Január",
    2: "Február",
    3: "Marec",
    4: "Apríl",
    5: "Máj",
    6: "Jún",
    7: "Júl",
    8: "August",
    9: "September",
    10: "Octóber",
    11: "November",
    12: "December"
  }
}, s = {
  showOptions: "Zobraziť možnosti",
  deleteCurrentValue: "Vymazať vybranú hodnotu"
}, i = {
  openCalendar: "Otvoriť kalendár",
  closeCalendar: "Zavrieť kalendár",
  dateRangeFromTo: (e, a) => `${e} do ${a}`
}, t = {
  openCalendar: "Otvoriť kalendár",
  closeCalendar: "Zavrieť kalendár"
}, d = {
  mandatory: "Povinné",
  optional: "Nepovinné"
}, p = {
  loading: "Načítava sa, čakajte prosím"
}, l = {
  closeModal: "Zatvoriť modálne okno"
}, c = {
  minLength: "Minimálne 8 znakov",
  upperCase: "Aspoň jedno veľké písmeno",
  number: "Aspoň jednu číslicu",
  specialChar: "Aspoň jeden špeciálny znak",
  tooltipSpecialChar: "Heslo musí obsahovať aspoň jeden špeciálny znak z uvedených ! \" # % & ' ( ) * + , - . / : ; < = > ? @ [  ] ^ _ ` { | } ~"
}, v = {
  showPassword: "Ukázať heslo",
  hidePassword: "Skryť heslo"
}, h = {
  showOptions: "Zobraziť možnosti",
  deleteCurrentValue: "Vymazať vybranú hodnotu"
}, u = {
  minus: "znížiť hodnotu",
  plus: "zvýšíť hodnotu",
  from: "Od",
  to: "Do"
}, k = {
  singleTag: "vybratá",
  fewTags: "vybraté",
  manyTags: "vybratých"
}, g = {
  openTime: "Otvoriť vyberač času",
  closeTime: "Zavrieť vyberač času"
}, m = {
  hour: "Výber Hodiny",
  minute: "Výber Minúty"
}, b = {
  close: "Zatvoriť"
}, z = {
  codeLabel: "Kód z obrázku",
  codeGenerate: "Vygenerovať nový",
  wrongCodeAlert: "Nesprávne zadaný kód z obrázku."
}, y = {
  displayedDataText: (e, a, o) => `Zobrazené dáta ${e} - ${a} z ${o}`,
  pageSizeLabel: "Počet položiek na stránku"
}, T = {
  percentageDiscount: (e) => `${e} % výška zľavy`
}, M = {
  heading: "Chýba dokument"
}, P = {
  error: {
    generic: "Prílohu sa nepodarilo načítať",
    deletion: "Prílohu sa nepodarilo vymazať",
    maxSize: "Príloha presahuje maximálnu veľkosť",
    mimeType: "Typ prílohy nie je podporovaný",
    maxCount: "Prekročený maximálny počet príloh",
    description: (e) => `Pre pokračovanie doplňte sken ${e.join(", ").replace(/,([^,]*)$/, " a$1")}.`
    // replace last comma with 'and'
  },
  withPersonName: (e, a) => `${e} | ${a}`,
  IDENTITY_CARD: {
    heading: "Občiansky preukaz (obidve strany)",
    error: "občianskeho preukazu (obidve strany)"
  },
  RESIDENCE_PERMISSION: {
    heading: "Povolenie na pobyt",
    error: "povolenia na pobyt"
  },
  PASSPORT: {
    heading: "Pas",
    error: "pasu"
  },
  DIPLOMATIC_PASSPORT: {
    heading: "Diplomatický pas",
    error: "diplomatického pasu"
  },
  IDENTITY_CARD_EU: {
    heading: "Občiansky preukaz EÚ (obidve strany)",
    error: "občianskeho preukazu EÚ (obidve strany)"
  },
  AUTHORITY: {
    heading: "Splnomocnenie",
    poaUnlimited: "Splnomocnenie na dobu neurčitú",
    identification: "Občiansky preukaz",
    error: "splnomocnenia"
  },
  COMMERCIAL_REGISTRY: {
    heading: "Výpis z obchodného registra",
    error: "výpisu z obchodného registra"
  },
  CONTRACTOR_REGISTRY: {
    heading: "Výpis zo živnostenského registra",
    error: "výpisu zo živnostenského registra"
  },
  DRIVER_LICENCE: {
    heading: "Vodičský preukaz",
    error: "vodičského preukazu"
  },
  PERMANENT_RESIDENCE: {
    heading: "Potvrdenie o prechodnom pobyte",
    error: "potvrdenia o prechodnom pobyte"
  },
  PAYMENT_CARD: {
    heading: "Výplatná páska",
    error: "výplatnej pásky"
  },
  INSURANCE_CARD: {
    heading: "Preukaz poistenca",
    error: "preukazu poistenca"
  },
  INCOME_STATEMENT: {
    heading: "Potvrdenie o výške príjmu",
    error: "potvrdenia o výške príjmu"
  },
  PAYSLIP: {
    heading: "Výplatná páska",
    error: "výplatnej pásky"
  },
  ACCOUNT_BALANCE: {
    heading: "Účtovná závierka",
    error: "účtovnej závierky"
  },
  PROFIT_AND_LOSS_STATEMENT: {
    heading: "Výkaz ziskov a strát",
    error: "výkazu ziskov a strát"
  },
  BALANCE_SHEET: {
    heading: "Rozvaha",
    error: "rozvahy"
  },
  TAX_DECLARATION: {
    heading: "Daň. priznanie vrátane príloh",
    error: "daň. priznania vrátane príloh"
  },
  VAT_TAX_DECLARATION: {
    heading: "Daňové priznanie k DPH",
    error: "daňového priznania k DPH"
  },
  SCHOOL_ATTENDANCE: {
    heading: "Potvrdenie o návšteve školy",
    error: "potvrdenia o návšteve školy"
  },
  LAST_PAID_INVOICE: {
    heading: "Posledná uhradená faktúra",
    error: "poslednej uhradenej faktúry"
  },
  BANK_STATEMENT: {
    heading: "Výpis z účtu",
    error: "výpisu z účtu"
  },
  CONTRACT_TERMINATION: {
    heading: "Výpoveď ZoPVS",
    error: "výpovede ZoPVS"
  },
  button: "Pridať dokument"
}, A = {
  title: "Zhrnutie objednávky",
  monthly: {
    title: "Mesačne",
    flatPrice: "Paušál",
    hwInstallment: "Splátka za zariadenia",
    hwInstallmentTogether: (e, a) => `Spolu ${e} € za ${a} mesiacov`,
    hwDiscount: "Zľava na zariadenia",
    insurance: "Poistenie"
  },
  firstInvoice: {
    title: "Do prvej faktúry"
  },
  purchase: {
    title: "Pri nákupe",
    downPayment: "Akontácia",
    simWithCredit: "SIM s kreditom",
    hw: "Zariadenia",
    guarantee: "Zábezpeka",
    coupon: "Úhrada poukážkou",
    exchange: "Okamžitá výmena"
  },
  proceed: "Prejsť k osobným údajom",
  addProducts: "Pridať ďalší tovar",
  price: (e, a) => `${e} €${a ? " mes." : ""}`
}, E = {
  checkoutHeaderLink: "Pokračovať v nákupe"
}, C = {
  addToComparison: "Pridať do porovnania",
  showComparison: "Zobraziť porovnanie",
  cancelComparison: "Zrušiť porovnanie",
  eshopHwDetailUrl: "/e-shop/produkt",
  eshopHwCompareUrl: "/e-shop/porovnavac"
}, N = {
  stockAvailability: {
    availableInEshop: "na sklade",
    availableOutsideEshop: "nedostupný v e-shope",
    unavailable: "dočasne nedostupný"
  },
  stockAvailabilityOrganization: {
    default: "na sklade predajne",
    availableInEshop: "na externom sklade",
    availableOutsideEshop: "nedostupný na sklade predajne",
    unavailable: "dočasne nedostupný"
  }
}, I = {
  close: "Zavrieť"
}, O = {
  priceOverrideTo: (e) => `Znížená cena platí do ${e}`,
  monthly: " mes.",
  oneTime: " jednorázovo",
  usage: " za využitie"
}, S = {
  title: "Pridať do porovnania",
  description: "Vyhľadajte produkt a pridajte ho do porovnania",
  placeholder: "Vyhľadať",
  willBeAdded: "Bude pridané",
  cancel: "Zrušiť",
  confirm: "Pridať do porovnania"
}, R = {
  buttons: {
    chooseFile: "Vybrať súbor",
    uploadFile: "Nahrať súbor"
  },
  chosenFile: "Vybraný súbor"
}, D = {
  renderError: "Ľutujeme, sekciu nebolo možné zobraziť"
};
export {
  T as addonMessages,
  r as alertMessages,
  M as attachmentsErrorMessages,
  P as attachmentsMessages,
  n as calendarWrapperMessages,
  z as captchaMessages,
  V as carouselMessages,
  A as cartSummaryMessages,
  E as checkoutHeaderMessages,
  s as comboBoxMessages,
  i as dateRangePickerMessages,
  t as dateTimePickerMessages,
  D as errorBoundaryMessages,
  d as fieldLabelMessages,
  C as hwCompareDockbarMessages,
  p as loaderMessages,
  l as modalMessages,
  y as paginationMessages,
  c as passwordIndicatorMessages,
  v as passwordMessages,
  O as priceMessages,
  S as searchHwModalMessages,
  h as selectMessages,
  N as skuAvailabilityMessages,
  u as sliderMessages,
  I as somethingWrongModalMessages,
  k as tagGroupMessages,
  m as timeFieldsMessages,
  g as timePickerMessages,
  b as toastProviderMessages,
  R as uploadFileMessages
};
//# sourceMappingURL=messages.js.map
